import React, { useCallback, useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import StarRating from 'sushiweb/StarRating';
import { OrderBill } from '../../../popups';
import './PaymentDetail.scss';
import { Modal, ModalHeader } from '../../../../UiKit';
import {
  ORDER_EVENTS,
  sendOrderModalEvents,
} from '../../../../helpers/analytics/order.analytics';

const paymentStatusMap = {
  0: 'Failure',
  1: 'Success',
};

export const PaymentDetail = (props) => {
  return (
    <div className='paymentDetailContainer'>
      {!props?.order ? (
        <Shimmer height='120px' width='100%' />
      ) : (
        <PaymentComp {...props} />
      )}
    </div>
  );
};

const PaymentComp = ({ order = null, orderId, userId }) => {
  const [isModalVisible, setModalVisibility] = useState(false);

  const showModal = () => {
    sendOrderModalEvents(ORDER_EVENTS.ORDER_BILL_MODAL_OPEN, orderId, userId);
    setModalVisibility(true);
  };

  const closePopup = () => {
    sendOrderModalEvents(ORDER_EVENTS.ORDER_BILL_MODAL_CLOSE, orderId, userId);
    setModalVisibility(false);
  };

  const paymentMethodImages = useCallback((images) => {
    if (typeof images === 'object') {
      images = Object.values(images);
    }
    if (!images?.length) return;

    return images.map((image, index) => {
      return (
        <div key={`${image}-${index}`} className='tw-w-[8rem] tw-my-4'>
          <img src={image} alt='' className='tw-w-full tw-h-auto' />
          {images.length > 1 && index !== images.length - 1 && (
            <span className='plusIcon'>+</span>
          )}
        </div>
      );
    });
  }, []);

  if (!order) return null;

  const paymentStatus =
    order && paymentStatusMap[order.payment_status]
      ? paymentStatusMap[order.payment_status]
      : '';

  return (
    <div className='paymentInfo' data-dd-privacy='mask'>
      <p>
        Payment
        <span className={`paymentStatus ${paymentStatus}`}>
          {' '}
          {paymentStatus}
        </span>
      </p>
      <p className='totalAmount'>
        {order.currency} {order.total_amount}
      </p>

      {/* Payment Images */}
      {paymentMethodImages(order.payment_method_images)}

      {order.payment_card_types && order.payment_card_types.length ? (
        <p>{order.payment_card_types[0]}</p>
      ) : null}
      <p
        tabIndex='0'
        role='button'
        className='viewBills colorGreen'
        onClick={showModal}
      >
        <span className='colorGreen'>View Order & Bill</span>
      </p>
      {isModalVisible ? (
        <Modal
          isVisible={isModalVisible}
          type='huge'
          titleComponent={
            <ModalHeader
              title='Items & billing'
              label={paymentStatus}
              bgColor={paymentStatus === 'Success' ? '#F6F9FD' : '#F7EBEC'}
              textColor={paymentStatus === 'Success' ? '#0366D6' : '#EE556A'}
              handleClose={closePopup}
            />
          }
          showCloseIcon={false}
          handleClose={closePopup}
          containerStyles={{
            display: 'flex',
            flexDirection: 'column',
          }}
          component={<OrderBill orderId={order.order_id} />}
        />
      ) : null}
    </div>
  );
};
